module.exports = __webpack_public_path__ + "img/threeGray.6b4b4091.png";